/* tslint:disable */
/* eslint-disable */
/**
 * Evidencna aplikacia API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface CiselnikPolozka
 */
export interface CiselnikPolozka {
    /**
     * 
     * @type {string}
     * @memberof CiselnikPolozka
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof CiselnikPolozka
     */
    'nazov': string;
}
/**
 * 
 * @export
 * @interface LegMaterialListItem
 */
export interface LegMaterialListItem {
    /**
     * 
     * @type {string}
     * @memberof LegMaterialListItem
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof LegMaterialListItem
     */
    'cisloLegislativnehoMaterialu': string;
    /**
     * 
     * @type {string}
     * @memberof LegMaterialListItem
     */
    'nazov': string;
    /**
     * 
     * @type {string}
     * @memberof LegMaterialListItem
     */
    'zaciatokStadia': string;
    /**
     * 
     * @type {CiselnikPolozka}
     * @memberof LegMaterialListItem
     */
    'typ': CiselnikPolozka;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const StadiumMaterialuEnum = {
    FinalnePredbezneStanovisko: 'FINALNE_PREDBEZNE_STANOVISKO',
    Mpk: 'MPK',
    PredVyhlasenimVZbierke: 'PRED_VYHLASENIM_V_ZBIERKE',
    PredpripravnaFazaUkoncena: 'PREDPRIPRAVNA_FAZA_UKONCENA',
    PripravaMaterialu: 'PRIPRAVA_MATERIALU',
    PriradenieGestora: 'PRIRADENIE_GESTORA',
    ProcesUkonceny: 'PROCES_UKONCENY',
    RokovanieNrsr: 'ROKOVANIE_NRSR',
    RokovaniePov: 'ROKOVANIE_POV',
    RokovanieVlada: 'ROKOVANIE_VLADA',
    SchvalenieGestora: 'SCHVALENIE_GESTORA',
    SchvalovanieMinister: 'SCHVALOVANIE_MINISTER',
    SpracovaniePredkladatel: 'SPRACOVANIE_PREDKLADATEL',
    VyhlaseneVZbierke: 'VYHLASENE_V_ZBIERKE',
    VyhodnotenieMpk: 'VYHODNOTENIE_MPK',
    VyhodnotenieMpkAkty: 'VYHODNOTENIE_MPK_AKTY',
    Vyjadrenia: 'VYJADRENIA',
    ZapisStanoviska: 'ZAPIS_STANOVISKA'
} as const;

export type StadiumMaterialuEnum = typeof StadiumMaterialuEnum[keyof typeof StadiumMaterialuEnum];



/**
 * LegislativnyMaterialListExternalApi - axios parameter creator
 * @export
 */
export const LegislativnyMaterialListExternalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get list of 10 latest processes in stadium.
         * @param {StadiumMaterialuEnum} stadiumMaterialu Stadium of legislativny material.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestLegMaterialList: async (stadiumMaterialu: StadiumMaterialuEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stadiumMaterialu' is not null or undefined
            assertParamExists('getLatestLegMaterialList', 'stadiumMaterialu', stadiumMaterialu)
            const localVarPath = `/legislativne-materialy/{stadiumMaterialu}/latest`
                .replace(`{${"stadiumMaterialu"}}`, encodeURIComponent(String(stadiumMaterialu)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LegislativnyMaterialListExternalApi - functional programming interface
 * @export
 */
export const LegislativnyMaterialListExternalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LegislativnyMaterialListExternalApiAxiosParamCreator(configuration)
    return {
        /**
         * Get list of 10 latest processes in stadium.
         * @param {StadiumMaterialuEnum} stadiumMaterialu Stadium of legislativny material.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestLegMaterialList(stadiumMaterialu: StadiumMaterialuEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LegMaterialListItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestLegMaterialList(stadiumMaterialu, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegislativnyMaterialListExternalApi.getLatestLegMaterialList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LegislativnyMaterialListExternalApi - factory interface
 * @export
 */
export const LegislativnyMaterialListExternalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LegislativnyMaterialListExternalApiFp(configuration)
    return {
        /**
         * Get list of 10 latest processes in stadium.
         * @param {StadiumMaterialuEnum} stadiumMaterialu Stadium of legislativny material.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestLegMaterialList(stadiumMaterialu: StadiumMaterialuEnum, options?: any): AxiosPromise<Array<LegMaterialListItem>> {
            return localVarFp.getLatestLegMaterialList(stadiumMaterialu, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LegislativnyMaterialListExternalApi - object-oriented interface
 * @export
 * @class LegislativnyMaterialListExternalApi
 * @extends {BaseAPI}
 */
export class LegislativnyMaterialListExternalApi extends BaseAPI {
    /**
     * Get list of 10 latest processes in stadium.
     * @param {StadiumMaterialuEnum} stadiumMaterialu Stadium of legislativny material.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegislativnyMaterialListExternalApi
     */
    public getLatestLegMaterialList(stadiumMaterialu: StadiumMaterialuEnum, options?: RawAxiosRequestConfig) {
        return LegislativnyMaterialListExternalApiFp(this.configuration).getLatestLegMaterialList(stadiumMaterialu, options).then((request) => request(this.axios, this.basePath));
    }
}



